import useSyncEnergyPerformanceCertificate from '@/api/mutations/energyPerformanceCertificate/useSyncEnergyPerformanceCertificate';
import { Button, ButtonProps, useToastContext } from '@payaca/ambrosia';

import { FC, useState } from 'react';
import { ConfirmSyncEnergyPerformanceCertificateModal } from './ConfirmSyncEnergyPerformanceCertificateModal';

type Props = { projectId?: string; addressId: string } & Omit<
  ButtonProps,
  'onClick' | 'isProcessing'
>;

export const SyncEnergyPerformanceCertificateButton: FC<Props> = (props) => {
  const [showModal, setShowModal] = useState(false);
  const { addressId, projectId, ...buttonProps } = props;
  const {
    mutateAsync: mutateSyncEpc,
    isPending: isSyncing,
    data,
  } = useSyncEnergyPerformanceCertificate({ projectId });

  const { pushSuccess, pushInfo, pushError } = useToastContext();

  const onClick = () => {
    if (isSyncing) return;
    void mutateSyncEpc({ addressId })
      .then((response) => {
        switch (response.syncEnergyPerformanceCertificate.__typename) {
          case 'SyncEnergyPerformanceCertificateConfirmationNeededResponse': {
            setShowModal(true);
            break;
          }
          case 'SyncEnergyPerformanceCertificateFoundResponse': {
            pushSuccess('The EPC has been synced successfully');
            break;
          }
          case 'SyncEnergyPerformanceCertificateUnchangedResponse': {
            pushInfo('The EPC has not changed');
            break;
          }
          case 'SyncEnergyPerformanceCertificateErrorResponse': {
            pushError(
              response.syncEnergyPerformanceCertificate.message ||
                'Something went wrong'
            );
            break;
          }
        }
      })
      .catch(() => {
        pushError('Something went wrong');
      });
  };

  return (
    <>
      <Button {...buttonProps} isProcessing={isSyncing} onClick={onClick} />
      {data?.syncEnergyPerformanceCertificate.__typename ===
        'SyncEnergyPerformanceCertificateConfirmationNeededResponse' && (
        <ConfirmSyncEnergyPerformanceCertificateModal
          isOpen={showModal}
          certificates={data.syncEnergyPerformanceCertificate.certificates}
          addressId={addressId}
          onClose={() => setShowModal(false)}
          projectId={projectId}
        />
      )}
    </>
  );
};
